import { createClient } from '@assetsJsModule/client/contact-form';

const client = createClient();

const sendContactForm = request => client.save(request);

export default sendContactForm;
